module.exports = __webpack_public_path__ + "static/media/icon-beratung.7435e5ca.svg";